import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// HOCS AUTH
import authGuard from '../../HOCs/authGuard';

// Custom components
//Componentes Atentus
import Availability from './components/Availability';
import Periodical from './Periodical'
import AvailabilityGauge from './components/AvailabilityGauge';
import ResponseTime from './components/ResponseTime';
import Statistics from './components/Statistics';
import Measurements from './components/Measurements';
import CallMetrics from './components/CallMetrics';
//material-ui
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import withWidth from '@material-ui/core/withWidth';
import { Box, FormControl, MenuItem, Select } from '@material-ui/core';

// Component styles
import PdfOnline from './PdfOnline';
import AvailabilityFlapping from './components/AvailabilityFlapping';

// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment-timezone'
import 'moment/locale/es'
import { autoRefreshSavedValue, autoRefreshTimeOptions, autoRefreshTimeSavedValue } from '../../utils/local-storage/auto-refresh-monitoreos';
import ToolsSection from './components/ToolsSections';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Tooltip } from '@mui/material';
import AtSelectPeriod from '../../components/AtSelectPeriod/AtSelectPeriod';
import { withTranslation } from 'react-i18next';
import { isFlindexClientAccess } from '../../hooks/useFlindexClientAccess';

moment.locale('es')
// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        //Custom Styles AP
        backgroundColor: '#e7e7e7',
    },
    button: {
        padding: theme.spacing(3),
        //Custom Styles AP
        backgroundColor: '#DDDDDD',
    },
    item: {
        height: '100%',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        }
    },
    itemGauge: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    modal: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        [theme.breakpoints.between('sm', 'lg')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    modalAlerts: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '50vw',
        [theme.breakpoints.between('sm', 'lg')]: {
            width: '50vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    modalEle: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        [theme.breakpoints.between('sm', 'lg')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '85vw',
        },
    },
    rootError: {
        paddingTop: theme.spacing(3),
        flexGrow: 1,
      },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        maxWidth: 500,
      },
    text: {
        color:'#FF7E00', 
        borderBottom:'1px solid #FF7E00'
    },
    subText: {
        color: theme.palette.text.secondary
    },
    bWhite:{
        backgroundColor:"white",
        //width: '100%',
    },
});

class Online extends Component {
    constructor(props) {
        
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.handlePeriod = this.handlePeriod.bind(this);
        this.handleMainPeriodical = this.handleMainPeriodical.bind(this);
        var offsetMachine=moment().utcOffset()*-1
        var utcTime=(moment().utcOffset(+offsetMachine))
        var offsetTz=(offsetMachine+utcTime.tz(sessionStorage.getItem('tz')).utcOffset())
        var date=utcTime.utcOffset(offsetTz)
        this.state = {
            props: props,
            showPeriodEvent:false,
            hasError: false,
            begin:moment(date._d).subtract({'hours': 1}),
            end:moment(date._d),
            limit:moment(date._d).subtract({'days': 30}),
            limit2:moment(date._d),
            checkedA: sessionStorage.getItem('extend_view') === "true",
            ObjectiveData:this.props.location.state.fromObjective,
            schedule:0,
            autoRefresh: autoRefreshSavedValue,
            autoRefreshTime: autoRefreshTimeSavedValue,
            globalPeriodValue: "",
            globalStatePeriod: null
        }
    }

    handleMainPeriodical=(e)=>{
        this.setState({
            filter:true,
            loadPdf:false,
            pdfOnlineDiv:false
        })
    }
    

    load=(e)=>{
        if(e.currentTarget.value==="online"){
            
            this.setState({
                pdfOnlineDiv:true,
                loadPdf:true
            })
        
        }else{
            this.setState({
                pdfOnlineDiv:false
            })
        }
    }

    handleSchedule=(event)=>{
        this.setState({
            schedule:event.currentTarget.id,
        })
    }
 


    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }

    
    handleShowPeriod = (event) => {   
        this.setState({
            showPeriodEvent: event.currentTarget,
        });
    };

    handlePeriod() {
        this.setState({
            showPeriodEvent:null,
        });
    }

    static getDerivedStateFromProps(props, state) {
        //console.log("derived", state.checkedA, sessionStorage.getItem('extend_view'))
        return null;
    }
    
   
    
    static getDerivedStateFromError(error) {
        return { hasError: true };
        //return null
      }
    componentDidUpdate(prevProps, prevState) {
        //console.log("update", prevState.checkedA, this.state.checkedA)
    }
    
    handleSwitch = name=>event => {
        sessionStorage.setItem('extend_view', event.target.checked)
        /*const newState = { ...this.state };
        newState['checkedA'] = event.target.checked ;     
        this.setState(newState);*/
        this.setState({ 
            checkedA: event.target.checked 
        });
    };

    handleChangeAutoRefresh = () => {
        this.setState((prevState) => ({
            autoRefresh: !prevState.autoRefresh
        }))
        localStorage.setItem('autoRefreshMonitoreos', !this.state.autoRefresh)
    }

    changeAutoRefreshTimeValue = (event) => {
        const value = event.target.value
        this.setState({autoRefreshTime: value})

        localStorage.setItem('autoRefreshTimeValue', value)
    }

    changeGlobalPeriod = ({ value, statePeriod }) => {
        this.setState({globalPeriodValue: value, globalStatePeriod: statePeriod})
    }
    
    render() {
        var md = 6
        var xl = 6
        
        const { classes, match } = this.props;
        const { showPeriodEvent, profileId,begin, end, limit, limit2, checkedA,pdfOnlineDiv,selectMonth, indexMonth, schedule} = this.state;
        const showPeriod = Boolean(showPeriodEvent);
        if (checkedA === true) {
            md = 12
            xl = 12
        }
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (this.state.hasError) {
            // Puedes renderizar cualquier interfaz de repuesto
            return <DashboardLayout title="Online" subtitle="Servicio" callbackFromParent={this.myCallback} isFirstTime={false}>
                        <div className={classes.rootError}>
                            <Paper className={classes.paper}>
                                <Grid
                                    container
                                    //spacing={4}
                                    justify="center"
                                    alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        xl={12}>
                                        <Typography variant="h1" className={classes.text}>{t('online.error.message.text.0')}</Typography>
                                        <Typography variant="h6" className={classes.subText}>{t('online.error.message.text.1')}</Typography>
                                        <Typography variant="h6" className={classes.subText}>{t('online.error.message.text.2')}</Typography>
                                        <Typography variant="h6" className={classes.subText}>{t('online.error.message.text.3')}</Typography>
                                        <Typography variant="h6" className={classes.subText}>{t('online.error.message.text.4')}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </div>
                    </DashboardLayout>

        }else if(pdfOnlineDiv===true){
            return(
                <PdfOnline 
                    params={this.props} schedule={schedule}
                    period="d" handleMainPeriodical={this.handleMainPeriodical}
                />
            )        
        }            
        else {
            return (
                <DashboardLayout title="Online" subtitle="Servicio" callbackFromParent={this.myCallback} isFirstTime={false}>
                    <div className={classes.root}>
                        {showPeriod?
                        <Periodical handlePeriod={this.handlePeriod} params={this.props}/>
                        :
                        <Grid
                            container
                            spacing={2}
                        >
                            {/* OBJETIVOS ACTIVOS */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                xl={6}
                                style={{display: "flex", alignItems: "end"}}
                            >
                                <ToolsSection {...this.props} handleClickShowPeriod={this.handleShowPeriod} />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                xl={6}
                                style={{paddingRight: "10px"}}
                            >
                                <Grid container>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box display='flex' alignItems='center' justifyContent='end'>
                                            <Typography variant='h6' style={{color: "#6b6b6b"}}>{t('online.switch.option.compact-view')}</Typography>
                                            <Box style={{marginLeft: '10px', marginRight: '10px'}}>
                                                <Switch
                                                    checked={this.state.checkedA}
                                                    onChange={this.handleSwitch('checkedA')}
                                                    value="checkedA"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                    color='primary'
                                                />
                                            </Box>
                                            <Typography variant='h6' style={{color: "#6b6b6b"}}>{t('online.switch.option.detailed-view')}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Box display='flex' justifyContent='end'>
                                            <Tooltip
                                                placement='bottom'
                                                title={`${this.state.autoRefresh ? t('online.auto-refresh.deactivate') : t('online.auto-refresh.activate')}`}
                                            >
                                                <IconButton
                                                    onClick={this.handleChangeAutoRefresh}
                                                    color={this.state.autoRefresh ? 'primary' : 'normal'}
                                                >
                                                    <RefreshIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <FormControl size='small'>
                                                <Select
                                                    variant="outlined"
                                                    size="small"
                                                    id='select-time-refresh'
                                                    value={this.state.autoRefreshTime}
                                                    onChange={this.changeAutoRefreshTimeValue}
                                                    style={{marginLeft: "15px", width: "270px", backgroundColor: "white"}}
                                                >
                                                    {autoRefreshTimeOptions.map(({label, value}) => {
                                                        return(
                                                            <MenuItem key={label} value={value}>{t(`refresh-period.${label}`)}</MenuItem>
                                                        )
                                                    })}
                                                </Select>                                                
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <AtSelectPeriod changePeriodFn={this.changeGlobalPeriod} persistInStorage={true} />
                                    </Grid>
                                </Grid>
                            </Grid>
                             <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                xl={6}
                            >
                                <AvailabilityGauge refreshTime={this.state.autoRefreshTime} title={t('online.graph.availability-gauge.global-uptime')} period="d" id="gauged-h" typePeriod={1} automaticUpdate={this.state.autoRefresh} real={true} size="25%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                xl={6}
                            >
                                <AvailabilityGauge refreshTime={this.state.autoRefreshTime} title={t('online.graph.availability-gauge.current-availability')} period="d" id="gauged-h" typePeriod={1} automaticUpdate={this.state.autoRefresh} size="25%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid> 
                            
                           {/* DISPONIBILIDAD CONSOLIDADA */}
                           <Grid
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}                                     
                            >
                                <Availability refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.availability')} period="d" id="availability-h" typePeriod={1} typeGraph={7} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" extendView={checkedA} globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>
                            
                            {/* TIEMPO DE RESPUESTA CONSOLIDADO */}
                            <Grid 
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}                             
                            >
                                <ResponseTime refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.response-time')} period="d" id="responseTime-h"  typePeriod={1} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>

                            {/* Disponibilidad con Flapping */}
                            {isFlindexClientAccess() ? (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                            >
                                <AvailabilityFlapping
                                    refreshTime={this.state.autoRefreshTime}
                                    automaticUpdate={this.state.autoRefresh}
                                    intervalo={this.state.schedule || 15}
                                />
                            </Grid>
                            ) : null}
                         

                            {/* Disponibilidad Total Consolidada */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}
                                //style={{border: "1px solid rgb(204, 204, 204)"}} 
                            >
                                <Availability refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.availability')} period="h" id="availability-h" typePeriod={0} typeGraph={0} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>
                            
                            {/* Tiempo de Respuesta: Frecuencia Absoluta */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                            >
                                <Statistics refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.response-time')} period="h" id="statistics-d" automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>

                            {/* TABLA Disponibilidad Downtime Global*/}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}   
                                //style={{border: "1px solid rgb(204, 204, 204)"}}                         
                            >
                                <Availability refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.availability')} period="d" id="availability-h" typePeriod={1} typeGraph={10} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>

                            {/* TABLA Disponibilidad Downtime Global Por Paso */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={md}
                                xl={xl}   
                                //style={{border: "1px solid rgb(204, 204, 204)"}}                         
                            >
                                <Availability refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.availability')} period="d" id="availability-h" typePeriod={1} typeGraph={6} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>
                            
                            {/* TABLA Panel Dinámico: Consolidación de Mediciones por ISP */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}   
                                //style={{border: "1px solid rgb(204, 204, 204)"}} 
                                                        
                            >
                                <Measurements refreshTime={this.state.autoRefreshTime} params={this.props} title={t('online.graph.availability-gauge.response-time-and-availability-by-isp')} period="d" id="availability-h" typePeriod={1} typeGraph={6} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                            </Grid>

                            {/* MÉTRICAS DE LLAMADA IVR */}
                            {this.state.ObjectiveData && this.state.ObjectiveData.servicio_id === 666 && (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                            >
                                <CallMetrics
                                    objetivoId={this.props.match.params.objetivo_id}
                                    userId={sessionStorage.getItem('user')}
                                />
                            </Grid>
                            )}
                            
                        </Grid>
                        }
                        
                    </div>
                </DashboardLayout>
            );
        }
        
    }
}


Online.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(withWidth(), withStyles(styles), withTranslation())(Online);